import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { userState } from "../../interface/MainInterface";
import * as AuthMain from "../../auth/AuthMain";
import { PasswordChangeForm } from "./MobilePassChpage";

interface propsType {
  userState: userState;
}

const MobileMypage = ({ userState }: propsType) => {
  const navigate = useNavigate();
  const [avatarUrl, setAvatarUrl] = useState("");
  const [coverUrl, setCoverUrl] = useState("");

  const getAvatarUrlByUserId = (userId: string) =>
    `https://detre-img.s3.ap-northeast-2.amazonaws.com/${userId}.png`;
  const getAvatarUrlByBg = (userId: string) =>
    `https://detre-img.s3.ap-northeast-2.amazonaws.com/bg-${userId}.png`;

  const handleLogout = () => {
    AuthMain.signOut();
    navigate("/memberlogin", { replace: true });
  };

  useEffect(() => {
    setAvatarUrl(getAvatarUrlByUserId(userState.userId));
    setCoverUrl(getAvatarUrlByBg(userState.userId));
  }, [userState.userId]);

  return (
    <Box sx={{ minHeight: "100%", bgcolor: "#f6f7fb", p: { xs: 2, sm: 3 }, pt: { xs: 5, sm: 7 } }}>
      <Box sx={{ width: "100%", maxWidth: "40rem", mx: "auto" }}>
        <Paper elevation={0} sx={{ overflow: "hidden", borderRadius: 3, border: "1px solid #e6e9f0" }}>
          <Box
            sx={{
              height: 168,
              position: "relative",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundImage: `linear-gradient(115deg, rgba(35, 47, 71, .84), rgba(69, 90, 124, .48)), url(${coverUrl})`,
            }}
          />

          <Box sx={{ px: { xs: 2.5, sm: 3 }, pb: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "center", mt: -6 }}>
              <Avatar
                alt={userState.userId}
                src={avatarUrl}
                sx={{ width: 104, height: 104, border: "4px solid #fff", boxShadow: "0 6px 18px rgba(21, 31, 49, .22)" }}
              />
            </Box>

            <Box sx={{ textAlign: "center", mt: 1.5, mb: 3 }}>
              <Typography variant="overline" sx={{ color: "#657089", fontWeight: 700, letterSpacing: ".08em" }}>
                MY COMMUNITY
              </Typography>
              <Typography
                variant="h6"
                noWrap
                fontWeight={800}
                color="#202637"
                sx={{ mt: 0.25, fontSize: { xs: "1rem", sm: "1.125rem" }, lineHeight: 1.4 }}
              >
                {userState.userName} 회원님 ({userState.readAddress})
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                내 프로필과 계정 정보를 관리할 수 있습니다.
              </Typography>
            </Box>

            <Divider />
            <Box component="section" sx={{ pt: 3 }}>
              <Typography variant="subtitle1" fontWeight={800} color="#202637">
                비밀번호 변경
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
                새로운 비밀번호를 입력하고 안전하게 변경하세요.
              </Typography>
              <PasswordChangeForm userState={userState} />
            </Box>

            <Divider sx={{ my: 3 }} />
            <Button
              variant="outlined"
              color="inherit"
              fullWidth
              onClick={handleLogout}
              sx={{ minHeight: 48, borderRadius: 2, borderColor: "#d8dde7", color: "#596174", fontWeight: 700 }}
            >
              로그아웃
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default MobileMypage;
